











import Vue from 'vue'
import { Component } from 'vue-property-decorator'
const version = require('@/../package.json').version

@Component
export default class Copyright extends Vue {
  public get appYear() {
    return new Date().getFullYear()
  }

  public get footerText() {
    return `Seb promo v${version}`
  }
}
